<template>
  <div v-if="isLoading">
    <label class="label text-sm mb-1">{{ $attrs.label }}</label>
    <div class="skeleton h-10 w-full" />
  </div>
  <form-autocomplete
    v-else
    v-bind="$attrs"
    :options="currencyOptions"
    :filter="filterCurrencies"
  >
    <template
      v-for="(_, name) in $slots"
      :key="name"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </form-autocomplete>
</template>

<script setup>
import { Currency, getCurrencyLabel } from '@/constants/currencies.js';

defineOptions({
  name: 'FormCurrencySelect',
});

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const currencyOptions = Object.values(Currency).map((code) => ({
  label: getCurrencyLabel(code),
  value: code,
}));

function filterCurrencies(option, search) {
  const term = search.toLowerCase();

  return option.label.toLowerCase().includes(term) || option.value.toLowerCase().includes(term);
}
</script>
